import { render, staticRenderFns } from "./ReportWitnessWithNumberplate.vue?vue&type=template&id=e9d7f78c&"
import script from "./ReportWitnessWithNumberplate.vue?vue&type=script&lang=ts&"
export * from "./ReportWitnessWithNumberplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports